var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-cta-list',{attrs:{"title":"Service groups","subtitle":"Here you find the current service groups","headers":_vm.headers,"storeNamespace":"services","listNamespace":"A_group","icon":_vm.logo,"buttonText":"New group"},scopedSlots:_vm._u([{key:"dialog-content",fn:function(ref){
var setDialog = ref.setDialog;
var dataId = ref.dataId;
return [_c('service-group-form',{attrs:{"listOnSave":true,"id":dataId},on:{"requestIsDone":function($event){return setDialog(false)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }